import { CommercialTerms } from '../../types/types'
import * as R from 'ramda'
import { VatBreakdownConfig } from './price-breakdown-types'
import { round } from './prices'
interface CommercialTermsForVAT {
  VAT?: string
  VAT_2?: string
  VAT_3?: string
}

const commercialTermsForVAT: Array<keyof CommercialTermsForVAT> = ['VAT', 'VAT_2', 'VAT_3']

export function getVatBreakdownConfig(commercialTerms: CommercialTerms): VatBreakdownConfig[] {
  return commercialTermsForVAT.map(ct => ({
    key: ct,
    vatStr: R.propOr('0', ct, commercialTerms),
    vat: Number(R.propOr('0', ct, commercialTerms))
  }))
}
export function vatPriceBreakdownCalulator(vatBreakdownConfig: VatBreakdownConfig[], priceWithoutVat: number) {
  return vatBreakdownConfig.map(vpc => ({
    key: vpc.key,
    vatStr: vpc.vatStr,
    vatPercentage: vpc.vat,
    annualVatPrice: round(priceWithoutVat * ((100 + vpc.vat) / 100) - priceWithoutVat)
  }))
}
